/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Examples_TitleInputs */

const es_prompt_tips_examples_title = /** @type {(inputs: Prompt_Tips_Examples_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dá ejemplos cuando sea posible`)
};

const en_prompt_tips_examples_title = /** @type {(inputs: Prompt_Tips_Examples_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give examples when possible`)
};

/**
* | output |
* | --- |
* | "Give examples when possible" |
*
* @param {Prompt_Tips_Examples_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_examples_title = /** @type {((inputs?: Prompt_Tips_Examples_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Examples_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_examples_title(inputs)
	return en_prompt_tips_examples_title(inputs)
});
export { prompt_tips_examples_title as "prompt_tips.examples_title" }